// src/lib/modalPremium.js — porte FIEL do showModalPremium do monolito (V2-M).
//
// Gera a MESMA marcação do monolito (.modal-prem-overlay / .modal-prem / .mp-head /
// .mp-stepper / .mp-body / .mp-foot / .mp-btn / .mp-vchip / .mp-sec / .mp-fld) para
// que o CSS canônico (_canonical.css) estilize idêntico.
//
// Diferença vs monolito: os bodies usam handlers inline (oninput/onblur). Para que
// funcionem sem refator, expomos os helpers genéricos no window (maskCpfCnpj,
// maskTelefone, _v2mpAtualizarStepper, _v2mpOnBlurCPFCNPJ/Email/Tel, copiarTexto,
// closeModal). Assim cada body é COPIADO VERBATIM do monolito. O botão Salvar é o
// único ponto wirado por JS (cfg.onSave) em vez de onclick string.

import { sb } from '../api/supabaseClient.js';
import { esc } from './dom.js';
import { showToast } from './toast.js';

let _escMP = null;

// ── Helpers de máscara / senha (portados do monolito) ───────────
export function maskCpfCnpj(input) {
  let v = input.value.replace(/\D/g, '');
  if (v.length <= 11) {
    v = v.replace(/(\d{3})(\d)/, '$1.$2')
         .replace(/(\d{3})(\d)/, '$1.$2')
         .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    v = v.replace(/^(\d{2})(\d)/, '$1.$2')
         .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
         .replace(/\.(\d{3})(\d)/, '.$1/$2')
         .replace(/(\d{4})(\d)/, '$1-$2');
  }
  input.value = v;
}

export function maskTelefone(input) {
  let v = input.value.replace(/\D/g, '');
  if (v.length <= 10) v = v.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  else                v = v.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
  input.value = v;
}

export function maskCPF(input) {
  let v = input.value.replace(/\D/g, '').slice(0, 11);
  v = v.replace(/(\d{3})(\d)/, '$1.$2');
  v = v.replace(/(\d{3}\.\d{3})(\d)/, '$1.$2');
  v = v.replace(/(\.\d{3})(\d)/, '$1-$2');
  input.value = v;
}

export function gerarSenhaTemp() {
  // Garante senha forte: >=1 minúscula, maiúscula, dígito e símbolo · 12 chars.
  const L = 'abcdefghjkmnpqrstuvwxyz', U = 'ABCDEFGHJKLMNPQRSTUVWXYZ', D = '23456789', S = '@#!$%';
  const all = L + U + D + S;
  const pick = (set) => set[Math.floor(Math.random() * set.length)];
  const pwd = [pick(L), pick(U), pick(D), pick(S)];
  while (pwd.length < 12) pwd.push(pick(all));
  for (let i = pwd.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); const t = pwd[i]; pwd[i] = pwd[j]; pwd[j] = t; }
  return pwd.join('');
}

export function copiarTexto(el) {
  const txt = el?.dataset?.copy || '';
  if (!txt) return;
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(txt).then(
      () => showToast('Copiado!'),
      () => showToast('Não foi possível copiar.', 'error'),
    );
  } else {
    const ta = document.createElement('textarea');
    ta.value = txt; document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); showToast('Copiado!'); }
    catch (e) { showToast('Não foi possível copiar.', 'error'); }
    document.body.removeChild(ta);
  }
}

// ── Stepper updater (idêntico ao _v2mpAtualizarStepper do monolito) ──
export function atualizarStepper(modalKey, etapas) {
  const stepper = document.querySelector('.mp-stepper[data-modal="' + modalKey + '"]');
  if (!stepper) return;
  const steps = stepper.querySelectorAll('.it');
  const conns = stepper.querySelectorAll('.conn');
  let firstPendente = -1;
  etapas.forEach((et, i) => {
    const ok = et.campos.length === 0
      ? true
      : et.campos.every((id) => {
          const el = document.getElementById(id);
          return el && (el.value || '').toString().trim().length > 0;
        });
    const s = steps[i];
    if (!s) return;
    const numSvg = s.querySelector('.num svg');
    const numSpan = s.querySelector('.num span');
    if (ok) {
      s.classList.add('done');
      s.classList.remove('active');
      if (numSvg) numSvg.style.display = '';
      if (numSpan) numSpan.style.display = 'none';
      const sec = document.querySelector('.mp-sec[data-step="' + i + '"]');
      if (sec) sec.classList.remove('locked');
    } else {
      s.classList.remove('done');
      if (numSvg) numSvg.style.display = 'none';
      if (numSpan) numSpan.style.display = '';
      if (firstPendente < 0) { s.classList.add('active'); firstPendente = i; }
      else s.classList.remove('active');
      const sec = document.querySelector('.mp-sec[data-step="' + i + '"]');
      if (sec) {
        if (firstPendente >= 0 && i > firstPendente) {
          sec.classList.add('locked');
          sec.classList.remove('active');
        } else if (i === firstPendente) {
          sec.classList.remove('locked');
          sec.classList.add('active');
        }
      }
    }
  });
  conns.forEach((c, i) => {
    const prevDone = steps[i] && steps[i].classList.contains('done');
    c.classList.toggle('done', prevDone);
  });
}

// ── Validação inline (.mp-vchip) ────────────────────────────────
export async function onBlurCPFCNPJ(input, tabela, campo, chipId, idAtual) {
  const chip = document.getElementById(chipId);
  if (!chip) return;
  const v = input.value;
  const vNum = (v || '').replace(/\D/g, '');
  if (!v) { chip.style.display = 'none'; input.classList.remove('ok', 'err'); return; }
  const tipo = vNum.length === 11 ? 'cpf' : vNum.length === 14 ? 'cnpj' : null;
  if (!tipo) {
    chip.style.display = 'inline-flex';
    chip.className = 'mp-vchip err';
    chip.innerHTML = '<svg><use href="#i-x"/></svg> Formato inválido';
    input.classList.add('err'); input.classList.remove('ok');
    return;
  }
  chip.style.display = 'inline-flex';
  chip.className = 'mp-vchip checking';
  chip.textContent = 'verificando...';
  try {
    let q = sb.from(tabela).select('id,nome_razao_social,nome,razao_social,nome_fantasia').or(`${campo}.eq.${vNum},${campo}.eq.${v}`);
    if (idAtual) q = q.neq('id', idAtual);
    const { data } = await q.limit(1);
    if (data && data.length) {
      const dup = data[0];
      const nome = dup.nome_razao_social || dup.nome_fantasia || dup.razao_social || dup.nome || 'registro';
      chip.className = 'mp-vchip warn';
      chip.innerHTML = '<svg><use href="#i-warning"/></svg> Já existe: <a>' + esc(nome) + '</a>';
      input.classList.add('err'); input.classList.remove('ok');
    } else {
      chip.className = 'mp-vchip ok';
      chip.innerHTML = '<svg><use href="#i-check"/></svg> Disponível';
      input.classList.add('ok'); input.classList.remove('err');
    }
  } catch (e) {
    chip.className = 'mp-vchip checking';
    chip.textContent = 'erro na verificação';
  }
}

export function onBlurEmail(input, chipId) {
  const chip = document.getElementById(chipId);
  if (!chip) return;
  const v = (input.value || '').trim();
  if (!v) { chip.style.display = 'none'; input.classList.remove('ok', 'err'); return; }
  const ok = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v);
  chip.style.display = 'inline-flex';
  if (ok) {
    chip.className = 'mp-vchip ok';
    chip.innerHTML = '<svg><use href="#i-check"/></svg> Email válido';
    input.classList.add('ok'); input.classList.remove('err');
  } else {
    chip.className = 'mp-vchip err';
    chip.innerHTML = '<svg><use href="#i-x"/></svg> Email inválido';
    input.classList.add('err'); input.classList.remove('ok');
  }
}

export function onBlurTel(input, chipId) {
  const chip = document.getElementById(chipId);
  if (!chip) return;
  const v = (input.value || '').replace(/\D/g, '');
  if (!v) { chip.style.display = 'none'; input.classList.remove('ok', 'err'); return; }
  const ok = v.length >= 10 && v.length <= 11;
  chip.style.display = 'inline-flex';
  if (ok) {
    chip.className = 'mp-vchip ok';
    chip.innerHTML = '<svg><use href="#i-check"/></svg> Formato BR ok';
    input.classList.add('ok'); input.classList.remove('err');
  } else {
    chip.className = 'mp-vchip err';
    chip.innerHTML = '<svg><use href="#i-x"/></svg> ' + v.length + ' dígitos (10-11)';
    input.classList.add('err'); input.classList.remove('ok');
  }
}

// ── Expõe helpers no window p/ handlers inline dos bodies (verbatim) ──
function _exposeHelpers() {
  window.maskCpfCnpj = maskCpfCnpj;
  window.maskTelefone = maskTelefone;
  window.maskCPF = maskCPF;
  window._v2mpAtualizarStepper = atualizarStepper;
  window._v2mpOnBlurCPFCNPJ = onBlurCPFCNPJ;
  window._v2mpOnBlurEmail = onBlurEmail;
  window._v2mpOnBlurTel = onBlurTel;
  window.copiarTexto = copiarTexto;
  window.closeModal = closeModalPremium;
}

// ── Root / container ────────────────────────────────────────────
// Tokens shadcn vivem em .sc-scope — como o modal é portal no <body>, a raiz
// carrega o escopo, senão var(--primary)/--background não resolvem (viram preto).
const _scopeClass = () => 'sc-scope' + (document.documentElement.classList.contains('light') ? '' : ' dark');

function _root() {
  let r = document.getElementById('modal-prem-root');
  if (!r) { r = document.createElement('div'); r.id = 'modal-prem-root'; document.body.appendChild(r); }
  r.className = _scopeClass();
  return r;
}

export function closeModalPremium() {
  if (_escMP) { document.removeEventListener('keydown', _escMP); _escMP = null; }
  const r = document.getElementById('modal-prem-root');
  if (r) r.innerHTML = '';
}

// ── showModalPremium(cfg) ───────────────────────────────────────
// cfg = { titulo, codigo, icoSvg, modalKey, etapas:[{lbl,campos}], body,
//         footInfo, btnSavetxt, btnSaveIcon, onSave }
export function showModalPremium(cfg) {
  _exposeHelpers();
  const root = _root();
  const etapas = cfg.etapas || [];
  const hasStepper = etapas.length > 1;
  const nEtapas = etapas.length;
  const subText = hasStepper ? `Cadastro · ${nEtapas} etapas` : 'Cadastro';
  const codigo = cfg.codigo || '';

  const stepperHTML = hasStepper ? `<div class="mp-stepper" data-modal="${cfg.modalKey || ''}">
    <div class="row">
      ${etapas.map((e, i) => `
        <div class="it ${i === 0 ? 'active' : ''}" data-step="${i}">
          <div class="num"><svg style="display:none"><use href="#i-check"/></svg><span>${i + 1}</span></div>
          <div class="lbl">${esc(e.lbl)}</div>
        </div>
        ${i < etapas.length - 1 ? '<div class="conn"></div>' : ''}
      `).join('')}
    </div>
  </div>` : '';

  const btnSave = `<button class="mp-btn mp-btn-save" data-mp-save>${cfg.btnSaveIcon ? `<svg><use href="#i-${cfg.btnSaveIcon}"/></svg>` : ''}${esc(cfg.btnSavetxt || 'Salvar')}</button>`;
  const footInfo = cfg.footInfo ? `<div class="mp-foot-info">${cfg.footInfo}</div>` : '<div class="mp-foot-info"></div>';

  root.innerHTML = `<div class="modal-prem-overlay">
    <div class="modal-prem">
      <div class="mp-head">
        <div class="ico"><svg><use href="#i-${cfg.icoSvg || 'usuario'}"/></svg></div>
        <div class="txt">
          <h2>${esc(cfg.titulo || '')}</h2>
          <div class="sub">${codigo ? `<span class="chip">${esc(codigo)}</span>` : ''} ${subText}</div>
        </div>
        <button class="help" data-mp-help title="Reportar problema (captura de tela)" aria-label="Abrir chamado"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><path d="M12 8v4M12 16h.01"/></svg></button>
        <button class="close" data-mp-close><svg><use href="#i-x"/></svg></button>
      </div>
      ${stepperHTML}
      <div class="mp-body">${cfg.body || ''}</div>
      <div class="mp-foot">
        ${footInfo}
        <div class="mp-foot-btns">
          <button class="mp-btn mp-btn-cancel" data-mp-close>Cancelar</button>
          ${btnSave}
        </div>
      </div>
    </div>
  </div>`;

  const overlay = root.querySelector('.modal-prem-overlay');
  overlay.addEventListener('mousedown', (e) => { if (e.target === overlay) closeModalPremium(); });
  root.querySelectorAll('[data-mp-close]').forEach((b) => b.addEventListener('click', closeModalPremium));
  root.querySelector('[data-mp-help]')?.addEventListener('click', async () => { const shot = window._capturarTelaSuporte ? await window._capturarTelaSuporte() : null; window.abrirModalChamado?.(shot); });

  const saveBtn = root.querySelector('[data-mp-save]');
  if (saveBtn) {
    saveBtn.addEventListener('click', async () => {
      if (typeof cfg.onSave !== 'function') return closeModalPremium();
      const orig = saveBtn.innerHTML;
      saveBtn.disabled = true; saveBtn.textContent = 'Salvando...';
      try {
        await cfg.onSave();
      } catch (e) {
        showToast(e?.message || 'Erro ao salvar', 'error');
      } finally {
        if (document.body.contains(saveBtn)) { saveBtn.disabled = false; saveBtn.innerHTML = orig; }
      }
    });
  }

  _escMP = (e) => { if (e.key === 'Escape') closeModalPremium(); };
  document.addEventListener('keydown', _escMP);

  // stepper inicial (modo edit já vem preenchido)
  if (hasStepper && cfg.modalKey) {
    setTimeout(() => { try { atualizarStepper(cfg.modalKey, etapas); } catch (e) {} }, 50);
  }
}

// ── LOTE 7 (shadcn flat): override visual do shell mp-* (lógica intacta) ──
(function _mpScFlat() {
  if (typeof document === 'undefined' || document.getElementById('mp-sc-flat')) return;
  const st = document.createElement('style'); st.id = 'mp-sc-flat';
  st.textContent = `
  .modal-prem-overlay{ background:rgba(0,0,0,.55)!important; }
  .modal-prem{ background:var(--background)!important; border-radius:10px!important;
    box-shadow:0 24px 60px rgba(0,0,0,.4)!important; }
  html.light .modal-prem{ background:#fff!important; }
  .mp-head, html.light .mp-head{ background:none!important; }
  .mp-btn{ border-radius:9px!important; font-weight:600!important; box-shadow:none!important; }
  .mp-btn:hover{ transform:none!important; }
  .mp-btn-save{ background:var(--primary)!important; color:var(--primary-foreground)!important; box-shadow:none!important; }
  .mp-btn-save:hover{ opacity:.9; box-shadow:none!important; }
  .mp-fld input:not([type=checkbox]):not([type=radio]), .mp-fld select, .mp-fld textarea{
    background:transparent!important; border:1px solid var(--border)!important; border-radius:8px!important;
    box-shadow:none!important; transition:border-color .12s, box-shadow .12s; }
  .mp-fld input:focus, .mp-fld select:focus, .mp-fld textarea:focus{
    outline:none!important; border-color:var(--muted-foreground)!important;
    box-shadow:0 0 0 3px rgba(128,128,140,.15)!important; }
  .mp-fld label{ font-weight:600!important; letter-spacing:.04em; }
  .mp-sec, .mp-sec.active, html.light .mp-sec, html.light .mp-sec.active{
    background:transparent!important; border:0!important; box-shadow:none!important;
    border-radius:0!important; padding:0 0 6px!important; }
  .mp-sec-head{ border-bottom:1px solid var(--border); padding-bottom:8px; margin-bottom:14px; }
  .mp-head .ico{ display:none!important; }
  .mp-sec.active .mp-sec-head .pill{ box-shadow:none!important; }
  .modal-prem::before{ display:none!important; }
  /* Padrão B (decisão 10/07): formulário contínuo — stepper some, seções sempre acessíveis */
  .mp-stepper{ display:none!important; }
  .mp-sec.locked{ opacity:1!important; filter:none!important; pointer-events:auto!important; }
  .mp-sec{ margin-bottom:12px!important; }
  /* chip de código e ajuda: neutros — o legado pedia var(--sc-info) (violeta),
     que dentro do .sc-scope é o CINZA de hover do shadcn → texto sumia no fundo */
  .mp-head .sub .chip{ background:var(--muted)!important; color:var(--muted-foreground)!important;
    border:1px solid var(--border)!important; }
  .mp-head .help{ background:transparent!important; color:var(--muted-foreground)!important;
    border:1px solid var(--border)!important; }
  .mp-head .close{ color:var(--muted-foreground)!important; }
  /* marcador de seção: numeral neutro, nunca pintado (vistoria 11/07) */
  .mp-sec-head .pill, .mp-sec.active .mp-sec-head .pill{
    width:20px!important; height:20px!important; border-radius:999px!important;
    background:var(--sc-info)!important; color:var(--sc-info-fg)!important;
    border:0!important; box-shadow:none!important; font:600 11px/1 inherit!important; }
  /* Padrão Elevado (11/07): campo tem fundo próprio */
  .mp-fld input, .mp-fld select, .mp-fld textarea{ background:var(--field)!important; }`;
  document.head.appendChild(st);
})();
